import React from 'react';
import ReactDOM from 'react-dom';

import { addLocaleData } from 'react-intl';
import { Provider } from 'react-redux';

/*
  Load locales that need to be supported
*/
import en from 'react-intl/locale-data';
import es from 'react-intl/locale-data/es';

/*
  We are still loading bootstrap via CSS directly. Not using css-modules here.
*/
import styles from 'bootstrap/dist/css/bootstrap.css';

import spreeStore from './store';
import ConnectedIntlProvider from './connected-intl-provider';
import Main from './components/main';

/*
  These are non css-modules styles.
*/
import './components/styles/theme-global.scss';
// import 'bootstrap/dist/css/bootstrap.min.css';

addLocaleData([...en, ...es]);

const app = (
    <Provider store={spreeStore}>
        <ConnectedIntlProvider>
            <Main style={styles} />
        </ConnectedIntlProvider>
    </Provider>
);

ReactDOM.render(
    app,
    document.getElementById('root'),
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/